import axios from "../../util/axios";

export default {
    /** 订单和购物车的统计 */
    queryOrderStatistic: () => axios.get({url: "/erp/common/queryOrderStatistic",}),
    /** 基础信息统计和AI商务统计*/
    queryBaseInfoStatistic: () => axios.get({url: "/erp/common/queryBaseInfoStatistic",}),
    /** 最近一周的订单统计 */
    queryOrderAmountStatistic: () => axios.get({url: "/erp/common/queryOrderAmountStatistic",}),
    /** 最近的未完成订单-20条 */
    queryCurrentOrder: () => axios.get({url: "/erp/common/queryCurrentOrder",}),
}